import { type Language } from "../constants";

// English is loaded eagerly (default language, always needed)
import en from "./en";

// All other languages are lazy-loaded
const loaders: Record<Language, () => Promise<{ default: Record<string, string> }>> = {
  en: () => Promise.resolve({ default: en }),
  zh: () => import("./zh"),
  ru: () => import("./ru"),
  es: () => import("./es"),
  hi: () => import("./hi"),
  ja: () => import("./ja"),
  de: () => import("./de"),
  it: () => import("./it"),
  fr: () => import("./fr"),
  sv: () => import("./sv"),
  fi: () => import("./fi"),
};

// Cache loaded translations
const cache: Partial<Record<Language, Record<string, string>>> = { en };

export async function loadTranslations(lang: Language): Promise<Record<string, string>> {
  if (cache[lang]) return cache[lang]!;
  
  try {
    const mod = await loaders[lang]();
    cache[lang] = mod.default;
    return mod.default;
  } catch {
    console.warn(`Failed to load translations for ${lang}, falling back to English`);
    return en;
  }
}

export function getTranslations(lang: Language): Record<string, string> {
  return cache[lang] || en;
}

export { en };

export type TranslationKey = keyof typeof en;
